import { useParams } from "react-router";
import LogsItemComponent from "../../components/Logs/LogsItem";
import { useLogsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
function LogsItem(){
    
    const params = useParams();
    const { data: log, error, isLoading } = useLogsByIdQuery(params.id??"0");

    
    const {translate}=useTrads();
    
    return (
        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : log ? (
            <div>
                <LogsItemComponent log={log}  />
            </div>
        ):null
    );
}
export default LogsItem;